import { AbsenceLimitsDto } from 'src/app/models/dtos/absence-limits-dto';
import { AbsenceLimitType } from 'src/app/models/enums/absence-limit-type';
import { formatDurationFromHours } from 'src/app/common/utils/formatters/duration-format';

export interface AmountDisplay {
  days: string;
  daysOrDash: string;
  hours: string;
  hoursOrDash: string;
}

export interface AbsenceLimitDisplay {
  current: AmountDisplay;
  due: AmountDisplay;
  overdue: AmountDisplay;
  currentUsed: AmountDisplay;
  dueUsed: AmountDisplay;
  overdueUsed: AmountDisplay;
  currentLeft: AmountDisplay;
  dueLeft: AmountDisplay;
  overdueLeft: AmountDisplay;
}

export function mapAbsenceLimitsToDisplay(
  absenceLimits: AbsenceLimitsDto[],
  locale: string,
): Partial<Record<AbsenceLimitType, AbsenceLimitDisplay>> {
  return absenceLimits.reduce<Partial<Record<AbsenceLimitType, AbsenceLimitDisplay>>>((map, absenceLimit) => {
    map[absenceLimit.AbsenceLimitTypeId] = toDisplay(absenceLimit, locale);
    return map;
  }, {});
}

function toDisplay(absenceLimit: AbsenceLimitsDto, locale: string): AbsenceLimitDisplay {
  return {
    current: createAmountDisplay(absenceLimit.Current, locale),
    due: createAmountDisplay(absenceLimit.Due, locale),
    overdue: createAmountDisplay(absenceLimit.Overdue, locale),
    currentUsed: createAmountDisplay(absenceLimit.CurrentUsed, locale),
    dueUsed: createAmountDisplay(absenceLimit.DueUsed, locale),
    overdueUsed: createAmountDisplay(absenceLimit.OverdueUsed, locale),
    currentLeft: createAmountDisplay(absenceLimit.CurrentLeft, locale),
    dueLeft: createAmountDisplay(absenceLimit.DueLeft, locale),
    overdueLeft: createAmountDisplay(absenceLimit.OverdueLeft, locale),
  };
}

function createAmountDisplay(amount: AbsenceLimitsDto['Due'], locale: string): AmountDisplay {
  return {
    days: amount?.Days?.toString() ?? '',
    daysOrDash: amount?.Days?.toString() ?? '-',
    hours: formatDurationFromHours(amount?.Hours, locale),
    hoursOrDash: amount?.Hours == null ? '-' : formatDurationFromHours(amount.Hours, locale),
  };
}
